import React from "react";
import {Formik} from "formik";
import {useDeleteBrandingTheme} from "../hooks/useDeleteBrandingTheme";
import {
  Button,
  Modal,
  ModalContent,
  ModalFooterButtons,
  Box,
  Text,
} from "@reside/ui";

type Values = Readonly<{
  confirmed: boolean;
}>;

type Props = Readonly<{
  themeName: string;
  isOpen: boolean;
  onRequestClose: () => void;
  themeId: string;
}>;

export const DeleteThemeModal = ({
  themeName,
  isOpen,
  onRequestClose,
  themeId,
}: Props) => {
  const {mutate: deleteTheme, isLoading} = useDeleteBrandingTheme();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={isLoading ? undefined : onRequestClose}
      title={`Delete Theme: ${themeName}`}
    >
      {({closeModal}) => (
        <Formik<Values>
          initialValues={{
            confirmed: true,
          }}
          onSubmit={() => {
            deleteTheme(themeId);
            onRequestClose();
          }}
        >
          {({submitForm}) => (
            <>
              <ModalContent>
                <Text as="p">
                  Are you sure you want to delete this theme? This action cannot
                  be undone.
                </Text>
              </ModalContent>
              <ModalFooterButtons>
                <Button
                  outline
                  color="primary"
                  disabled={isLoading}
                  onClick={closeModal}
                  testId="closeDeleteThemeModalButton"
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  color="danger"
                  disabled={isLoading}
                  onClick={submitForm}
                  testId="deleteThemeButton"
                >
                  {isLoading ? "Deleting..." : "Delete"}
                </Button>
              </ModalFooterButtons>
            </>
          )}
        </Formik>
      )}
    </Modal>
  );
};
